import { useEffect, useState } from "react";
import Api from "../../shared/api/api";
import "../styles/CartModal.css";

export default function CartModal({ onClose }) {
  const [items, setItems] = useState([]);

  // ⭐ NEW: Discount system
  const [discountCode, setDiscountCode] = useState("");
  const [discountError, setDiscountError] = useState("");

  const loadCart = async () => {
    const sessionId = localStorage.getItem("merch_session_id");
    const res = await Api.getCartItems(sessionId);

    let cart = [];

    if (Array.isArray(res)) {
      cart = res;
    } else if (Array.isArray(res?.items)) {
      cart = res.items;
    } else if (Array.isArray(res?.cart_items)) {
      cart = res.cart_items;
    } else if (res?.data) {
      if (Array.isArray(res.data.items)) cart = res.data.items;
      if (Array.isArray(res.data.cart_items)) cart = res.data.cart_items;
    }

    setItems(cart);
  };

  useEffect(() => {
    loadCart();
  }, []);

  const removeItem = async (id) => {
    await Api.removeFromCart(id);
    await loadCart(); // ⭐ FIX: reload local cart state
    window.dispatchEvent(new Event("cart-updated"));
  };

  const updateQty = async (id, delta) => {
    const item = items.find((i) => i.id === id);
    if (!item) return;

    const newQty = item.quantity + delta;

    if (newQty <= 0) {
      return removeItem(id);
    }

    await Api.updateCartItemQty(id, newQty);
    await loadCart(); // ⭐ FIX: reload local cart state
    window.dispatchEvent(new Event("cart-updated"));
  };

  const handleCheckout = async () => {
    try {
      const sessionId = localStorage.getItem("merch_session_id");
      const res = await Api.createCheckoutSession(sessionId);

      if (res.url) {
        window.location.href = res.url;
      } else {
        alert("Could not start checkout.");
      }
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Checkout failed.");
    }
  };

  // ⭐ Apply discount
  const applyDiscount = async () => {
    try {
      const sessionId = localStorage.getItem("merch_session_id");
      if (!sessionId) {
        setDiscountError("No session found.");
        return;
      }

      const res = await Api.applyDiscountToCart(sessionId, discountCode);

      if (!res.success) {
        setDiscountError(res.error || "Invalid or expired code.");
        return;
      }

      setDiscountError("");
      await loadCart(); // reload cart w/ discounts
      window.dispatchEvent(new Event("cart-updated"));
    } catch (err) {
      console.error("DISCOUNT ERROR:", err);
      setDiscountError("Error applying code.");
    }
  };

  // ⭐ Updated total calculation
  const total = items.reduce((sum, item) => {
    const basePrice =
      item.item_type === "book"
        ? item.book_price
        : item.price_at_time;

    const discount = item.discount_amount || 0;
    const finalPrice = (basePrice - discount) * item.quantity;

    return sum + finalPrice;
  }, 0);

  return (
    <div className="cart-modal-overlay" onClick={onClose}>
      <div className="cart-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-cart" onClick={onClose}>
          ✕
        </button>

        <h2>Your Cart</h2>

        {items.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <>
            <ul className="cart-list">
              {items.map((item) => {
                const basePrice =
                  item.item_type === "book"
                    ? item.book_price
                    : item.price_at_time;

                const discount = item.discount_amount || 0;
                const finalPrice = basePrice - discount;

                return (
                  <li key={item.id} className="cart-item">
                    <img
                      src={item.book_image_url || item.image_url}
                      alt={item.book_title || item.title}
                    />

                    <div className="cart-item-details">
                      <strong>{item.book_title || item.title}</strong>
                      <div className="variant">
                        {item.item_type === "book"
                          ? item.book_format
                          : item.variant_title}
                      </div>

                      <div className="qty-controls">
                        <button onClick={() => updateQty(item.id, -1)}>-</button>
                        <span>{item.quantity}</span>
                        <button onClick={() => updateQty(item.id, 1)}>+</button>
                      </div>

                      <button
                        className="remove-button"
                        onClick={() => removeItem(item.id)}
                      >
                        Remove
                      </button>

                      {/* ⭐ Price breakdown */}
                      <div className="price-breakdown">
                        {/* 1. Base price */}
                        <p className="base-price">
                          ${Number(basePrice).toFixed(2)} each
                        </p>

                        {/* 2. Base subtotal */}
                        {discount > 0 && (
                          <p className="base-subtotal">
                            ${(Number(basePrice) * item.quantity).toFixed(2)} Before Coupon
                          </p>
                        )}

                        {/* 3. Discount */}
                        {discount > 0 && (
                          <p className="discount-line">
                            - ${Number(discount * item.quantity).toFixed(2)} Coupon Discount
                          </p>
                        )}

                        {/* 4. Final subtotal */}
                        <p className="final-price">
                          ${(finalPrice * item.quantity).toFixed(2)} Sub-Total
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>

            {/* ⭐ Discount Code UI */}
            <div className="discount-section">
              <input
                type="text"
                placeholder="Discount code"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                className="discount-input"
              />
              <button className="discount-apply" onClick={applyDiscount}>
                Apply
              </button>
              {discountError && (
                <p className="discount-error">{discountError}</p>
              )}
            </div>

            <button
              className="checkout-btn"
              style={{
                marginTop: "15px",
                padding: "10px 20px",
                background: "#6c43f3",
                color: "white",
                borderRadius: "6px",
                border: "none",
                fontSize: "16px",
                cursor: "pointer",
              }}
              onClick={handleCheckout}
            >
              Checkout
            </button>

            <div className="cart-total">
              <strong>Total: ${total.toFixed(2)}</strong>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
